import React, { Component } from "react";
import RegistrationLink from "./RegistrationLink";

class AddUser extends Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    const userName = e.target.elements.user.value;
    const email = e.target.elements.email.value;

    const user = {
      id: Number(new Date()),
      userName: userName,
      email: email,
      createdBy: this.props.auth.email,
    };

    if (userName && email) {
      // this.props.addPost(post)
      this.props.startAddingUser(user);
      this.props.history.push("/");
    }
  }

  render() {
    if (this.props.auth.authenticated === false) {
      return <RegistrationLink />;
    }
    return (
      <div className="container">
        <form className="form" onSubmit={this.handleSubmit}>
          <input type="text" placeholder="User Name" name="user" />
          <input type="text" placeholder="Email" name="email" />
          <button>Add</button>
        </form>
      </div>
    );
  }
}

export default AddUser;
